import type { ComponentType } from "react";
import {
  IconCheck,
  IconChecklist,
  IconNumber,
  IconPercent,
  type IconProps,
} from "./icons";
import type { ProgressType } from "../types";

export interface ProgressTypeOption {
  key: ProgressType;
  label: string;
  /** Two words at most — it sits under the label in the picker. */
  hint: string;
  Icon: ComponentType<IconProps>;
}

/**
 * How a goal gets marked done, in the order the picker shows them.
 *
 * Both the create dialog and the goal row read this, so a goal is described the
 * same way when you pick the type and when you change your mind about it.
 */
export const PROGRESS_TYPES: readonly ProgressTypeOption[] = [
  { key: "checkbox", label: "Галочка", hint: "зроблено чи ні", Icon: IconCheck },
  { key: "number", label: "Число", hint: "скільки з цілі", Icon: IconNumber },
  { key: "percent", label: "Відсоток", hint: "ставлю вручну", Icon: IconPercent },
  { key: "checklist", label: "Підзадачі", hint: "по пунктах", Icon: IconChecklist },
];
